(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/models/tips-info.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/models/tips-info.js'); 
'use strict';

svs.maltipset.models.TipsInfo = Backbone.Model.extend({
  preserve: true,
  preserveBindings: true,
  initialize: function() {
    var storageTipsInfo = svs.components.Storage.browser.get(
      'tipsInfo',
      'Maltipset'
    );

    if (storageTipsInfo) {
      this.set(storageTipsInfo);
    }
    this.listenTo(this, 'change', this.storeTipsInfo, this);
  },
  storeTipsInfo: function() {
    svs.components.Storage.browser.set(
      'tipsInfo',
      'Maltipset',
      this.toJSON(),
      svs.components.Storage.constants.EXPIRES_1WEEK
    );
  },
  tipsInfoActive: function() {
    return this.get('curveChecked') || this.get('papersChecked');
  },
  getNumberOfTipsinfo: function() {
    return this.get('curveChecked') + this.get('papersChecked');
  },
  emptyTipsInfo: function() {
    this.set(this.defaults());
  },
  defaults: function() {
    return {
      curveChecked: true,
      papersChecked: true
    };
  }
});

 })(window);